import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AdminShared.css";

export default function AdminStatsPage() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    rpc: "",
    instructors: "",
    reviews: "",
    students: "",
    courses: "",
    certificates: ""
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const adminInfo = localStorage.getItem("adminInfo");
    if (!adminInfo) return navigate("/admin");
    fetchStats();
  }, [navigate]);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://siteapi.flytutor.in/api/stats");
      setStats(res.data);
    } catch (err) {
      console.log("Stats fetch failed");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setStats({ ...stats, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
        setLoading(true);
        await axios.put("https://siteapi.flytutor.in/api/stats", stats);
        alert("Operational metrics updated successfully.");
    } catch (err) {
        alert("Failed to update metrics.");
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Metric Analytics</h1>
        </div>
        <div className="module-badge" style={{ background: '#8b5cf6' }}>Global Stats</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#8b5cf6' }}></div>
            Status: Metrics Management Node
          </div>
        </div>

        <div className="admin-table-wrapper" style={{ padding: '40px', background: '#fff' }}>
            <h2 style={{ marginBottom: '30px', fontWeight: 800 }}>Update Operational Data</h2>
            
            <div className="admin-form-elite" style={{ padding: 0, border: 'none', boxShadow: 'none' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '30px' }}>
                    <label>RPC Threshold
                        <input type="number" name="rpc" value={stats.rpc} onChange={handleChange} />
                    </label>
                    <label>Active Instructors
                        <input type="number" name="instructors" value={stats.instructors} onChange={handleChange} />
                    </label>
                    <label>Verified Reviews
                        <input type="number" name="reviews" value={stats.reviews} onChange={handleChange} />
                    </label>
                    <label>Student Base
                        <input type="number" name="students" value={stats.students} onChange={handleChange} />
                    </label>
                    <label>Available Courses
                        <input type="number" name="courses" value={stats.courses} onChange={handleChange} />
                    </label>
                    <label>Issued Certificates
                        <input type="number" name="certificates" value={stats.certificates} onChange={handleChange} />
                    </label>
                </div>

                <div style={{ marginTop: '40px', display: 'flex', gap: '15px' }}>
                    <button className="btn-primary-elite" onClick={handleSubmit} disabled={loading} style={{ width: '200px' }}>
                        {loading ? "Updating..." : "Commit Changes"}
                    </button>
                    <button className="btn-update" style={{ background: '#f1f5f9', border: 'none' }} onClick={() => navigate("/admin/panel")}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}
